import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

async function start() {
  if (import.meta.env.VITE_MOCK === '1') {
    const { installMockApi } = await import('./mocks/mockApi');
    installMockApi();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
